import { Box } from "@mui/material";
import { teal } from "@mui/material/colors";
import React from "react";

const JobExecutionStatus = ({ status }) => {
  let background = "#E0E0E0";
  let colors = {
    NOT_PUBLISHED: "#fc8452",
    SCHEDULED: "#73c0de",
    QUEUED: "#586413",
    IN_PROGRESS: "#586413",
    SUCCEEDED: "#3ba272",
    FAILED: "#f44336",
    TIMED_OUT: "#f44336",
    REJECTED: "#f44336",
    REMOVED: "#f44336",
    CANCELED: "#ee6666",
  };

  let color = colors[status] || background;
  return (
    <Box
      sx={{
        height: "20px",
        width: "130px",
        textAlign: "center",
        display: "inline",
        fontSize: 10,
        background: color,
        borderRadius: "5px",
        color: "white",
        padding: "4px 7px",
        fontWeight: "bold",
      }}
    >
      {status.replace(/_/g, " ")}
    </Box>
  );
};

export default JobExecutionStatus;
